export class DeviceGroupPolicyVaultNotInitializedError extends Error {
    constructor() {
        super('Root entry is missing. Vault not initialized.');
        this.name = 'DeviceGroupPolicyVaultNotInitializedError';
    }
}
